<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 50%; min-width: 45rem;">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">Checkout Patient Bag</h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0"></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <form class="action-modal" @submit.prevent>
                            <div class="form-section-container" style="display: flex; flex-direction: column; width: 100%; gap: 20px;">
                                
                                <div class="individual-patient-container" style="padding: 12px; background-color: #f5f9ff; border-radius: 6px; border: 1px solid #d0e3ff;">
                                    <h4 style="margin: 0 0 10px 0; border-bottom: 1px solid #d0e3ff; padding-bottom: 5px;">Bag Information</h4>
                                    <div class="patient-result-info" style="text-align: left; display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
                                        <p style="margin: 0; font-size: 0.95em;">
                                            <b>{{ $resident({ capitalize: true }) }}:</b> {{ patientName }}
                                        </p>
                                        <p style="margin: 0; font-size: 0.95em;">
                                            <b>Bag ID:</b> {{ bag.bag_id || 'N/A' }}
                                        </p>
                                        <p style="margin: 0; font-size: 0.95em;">
                                            <b>Check-in Date:</b> {{ formatDate(bag.check_in_date) }}
                                        </p>
                                        <p style="margin: 0; font-size: 0.95em;">
                                            <b>Current Meds Count:</b> {{ bag.items ? bag.items.length : 0 }}
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    <p style="text-align: left; font-weight: bold; margin-bottom: 5px;">Checkout Notes</p>
                                    <textarea v-model="notes" rows="4" style="width: 100%; border-radius: 4px; padding: 10px; border: 1px solid #ccc; font-family: inherit;" placeholder="Enter notes for this checkout..."></textarea>
                                </div>
                                
                                <div>
                                    <p style="text-align: left; font-weight: bold; margin-bottom: 5px; color: #d9381e;">
                                        <i class="pi pi-info-circle"></i> This action will completely check out this bag, moving its remaining inventory out of stock.
                                    </p>
                                </div>
                            </div>
                        </form>
                    </slot>
                </div>
                <p style="color: red; font-weight: 500; font-size: 1em; text-align: center; margin-top: 10px; margin-bottom: 0;" v-if="errorMessage">{{ errorMessage }}</p>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 15px 20px;">
                    <slot name="footer">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px; cursor: pointer; padding: 8px 20px; border-radius: 4px;" @click="closeModal">Cancel</p>
                        <p class="regular-button green-button" style="cursor: pointer; padding: 8px 20px; border-radius: 4px;" @click="submitCheckout">Sign Off</p>
                    </slot>
                </div>
            </div>
        </div>
        
        <SignatureModal v-if="displaySignatureModal" :payload="realSubmit" :dual="requiresDoubleSig" @isSuccessful="isSuccessful" @close="closeSignature" endpoint="/checkout-pom" />
    </div>
</template>

<script>
import SignatureModal from '@/components/modals/SignatureModal.vue';
import { drugsRequireDoubleSig } from '@/services/doubleSignature';

export default {
    components: {
        SignatureModal
    },
    props: {
        bag: Object
    },
    data() {
        return {
            notes: '',
            displaySignatureModal: false,
            errorMessage: ''
        }
    },
    computed: {
        patientName() {
            const p = this.bag?.patient;
            if (!p) return 'N/A';
            const info = p.latest_personal_information || p.personal_information;
            if (!info) return 'N/A';
            const first = info.firstname || info.first_name || '';
            const last = info.lastname || info.last_name || '';
            return `${first} ${last}`.trim() || 'N/A';
        },
        // Checking a bag out moves ALL of its remaining inventory out of stock, so if the bag
        // holds an S8 (or anything else the facility nominates) it needs a witness just like
        // every other movement. SignatureModal's own `dualForMeds` check can't work this out
        // here because this payload carries no `drugs`/`stock_items` array - the endpoint takes
        // the bag as a whole - so the requirement is passed explicitly via `:dual`.
        requiresDoubleSig() {
            const facility = this.$store.getters.getCurrentLocation?.facility;
            return drugsRequireDoubleSig(this.bag?.items, facility);
        },
        realSubmit() {
            return {
                bag_id: this.bag?.uuid,
                notes: this.notes
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        closeSignature() {
            this.displaySignatureModal = false;
        },
        submitCheckout() {
            if (!this.bag || !this.bag.uuid) {
                this.errorMessage = "Invalid bag.";
                return;
            }
            this.displaySignatureModal = true;
        },
        isSuccessful(res) {
            this.$emit('successful');
        },
        formatDate(dateStr) {
            if (!dateStr) return '--';
            const d = new Date(dateStr);
            const pad = (n) => (n < 10 ? '0' + n : n);
            const ampm = d.getHours() >= 12 ? 'PM' : 'AM';
            let hours = d.getHours() % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(hours)}:${pad(d.getMinutes())} ${ampm}`;
        }
    }
}
</script>

<style scoped>
/* Inherits modal styles from global CSS */
</style>
